export default "__VITE_ASSET__Z3pXPgB3__"